import GroupsIcon from '@mui/icons-material/Groups';
import HandshakeIcon from '@mui/icons-material/Handshake';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import { Box, Card, CardContent, Grid, Typography } from '@mui/material';

// import { useNavigate } from 'react-router-dom';

/**
 * Collaboration options section with three main partnership types
 *
 * @returns {JSX.Element} Collaboration options grid component
 */
function CollaborationOptionsSection() {
  // const _navigate = useNavigate();

  const collaborationOptions = [
    {
      title: 'Join as a Consultant',
      description:
        'Become part of our expert network and help organizations transform their technology landscape.',
      icon: <GroupsIcon sx={{ fontSize: 48, color: 'var(--color-primary)' }} />,
      buttonText: 'Learn More',
      path: '/join-consultant',
      benefits: [
        'Flexible engagement models',
        'Access to enterprise clients',
        'Continuous learning opportunities',
        'Competitive compensation',
      ],
    },
    {
      title: 'Join as a Services Integrator',
      description:
        'Partner with us to deliver comprehensive technology solutions to enterprise clients.',
      icon: (
        <HandshakeIcon sx={{ fontSize: 48, color: 'var(--color-primary)' }} />
      ),
      buttonText: 'Partner With Us',
      path: '/join-integrator',
      benefits: [
        'Strategic partnerships',
        'Joint go-to-market',
        'Revenue sharing models',
        'Technical collaboration',
      ],
    },
    {
      title: 'Collaborate With Us',
      description:
        "Explore custom collaboration opportunities tailored to your organization's needs.",
      icon: (
        <RocketLaunchIcon
          sx={{ fontSize: 48, color: 'var(--color-primary)' }}
        />
      ),
      buttonText: 'Start Collaboration',
      path: '/collaborate',
      benefits: [
        'Custom engagement models',
        'Innovation partnerships',
        'Technology co-creation',
        'Strategic advisory',
      ],
    },
  ];

  return (
    <Grid container spacing={4}>
      {collaborationOptions.map((option, index) => {
        const isEven = index % 2 === 0;
        return (
          <Grid item xs={12} md={4} key={index}>
            <Card
              sx={{
                height: '100%',
                maxWidth: '350px',
                width: '100%',
                mx: 'auto',
                display: 'flex',
                flexDirection: 'column',
                position: 'relative',
                borderRadius: isEven ? '0 12px 12px 0' : '12px 0 0 12px',
                border: '1px solid var(--color-border)',
                transition: 'all 0.3s ease',
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: -1,
                  left: isEven ? -1 : 'auto',
                  right: !isEven ? -1 : 'auto',
                  width: '60px',
                  height: '60px',
                  borderTop: '3px solid var(--color-primary)',
                  borderLeft: isEven
                    ? '3px solid var(--color-primary)'
                    : 'none',
                  borderRight: !isEven
                    ? '3px solid var(--color-primary)'
                    : 'none',
                  borderRadius: 0,
                },
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  bottom: -1,
                  right: isEven ? -1 : 'auto',
                  left: !isEven ? -1 : 'auto',
                  width: '60px',
                  height: '60px',
                  borderBottom: '3px solid var(--color-primary)',
                  borderRight: isEven
                    ? '3px solid var(--color-primary)'
                    : 'none',
                  borderLeft: !isEven
                    ? '3px solid var(--color-primary)'
                    : 'none',
                  borderRadius: 0,
                },
                '&:hover': {
                  transform: 'translateY(-8px)',
                  boxShadow: '0 12px 40px rgba(0, 0, 0, 0.15)',
                },
              }}
            >
              <CardContent
                sx={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  p: 4,
                }}
              >
                {/* Icon */}
                <Box sx={{ mb: 3, textAlign: 'center' }}>{option.icon}</Box>

                {/* Title */}
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 600,
                    fontSize: '1.75rem',
                    mb: 2,
                    color: 'var(--color-heading)',
                    textAlign: 'center',
                  }}
                >
                  {option.title}
                </Typography>

                {/* Description */}
                <Typography
                  sx={{
                    color: 'var(--color-text-muted)',
                    mb: 3,
                    lineHeight: 1.6,
                    textAlign: 'center',
                  }}
                >
                  {option.description}
                </Typography>

                {/* Benefits */}
                <Box sx={{ mb: 4, flex: 1 }}>
                  {option.benefits.map((benefit, idx) => (
                    <Typography
                      key={idx}
                      sx={{
                        color: 'var(--color-card-text)',
                        fontSize: '0.95rem',
                        mb: 1,
                        pl: 2,
                        position: 'relative',
                        '&::before': {
                          content: '"•"',
                          position: 'absolute',
                          left: 0,
                          color: 'var(--color-primary)',
                          fontWeight: 'bold',
                        },
                      }}
                    >
                      {benefit}
                    </Typography>
                  ))}
                </Box>

                {/* Button */}
                {/* <Button
                  variant="contained"
                  onClick={() =>
                    window.open(
                      'https://www.linkedin.com/company/rsm-collective/',
                      '_blank',
                      'noopener,noreferrer'
                    )
                  }
                  aria-label="Contact RSM Collective on LinkedIn (opens in new window)"
                  sx={{
                    backgroundColor: 'var(--color-primary)',
                    color: 'white',
                    py: 1.5,
                    fontWeight: 600,
                    textTransform: 'none',
                    fontSize: '1rem',
                    borderTopLeftRadius: 0,
                    borderTopRightRadius: '16px',
                    borderBottomLeftRadius: '16px',
                    borderBottomRightRadius: 0,
                    '&:hover': {
                      backgroundColor: '#658309',
                    },
                  }}
                >
                  {option.buttonText}
                </Button> */}
              </CardContent>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  );
}

export default CollaborationOptionsSection;
